import { useState, useEffect } from 'react';
import { getLanguages, getModelLanguages, getIAModels } from '../utils/config-calls';
import debug from '@commons-shared/debug';
import { config } from '../config/environment';

export const useConfigData = () => {
  const [languages, setLanguages] = useState([]);
  const [models, setModels] = useState({ text: [], vision: [], translation: [] });
  const [aiWorkingLanguages, setAiWorkingLanguages] = useState([]);

  // Charger les langues disponibles
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await getLanguages();
        if (response.success) {
          setLanguages(response.languages);
        }
      } catch (error) {
        debug.error(config, 'Error fetching languages:', error);
      }
    };
    fetchLanguages();
  }, []);

  // Charger les modèles IA
  useEffect(() => {
    const fetchModels = async () => {
      try {
        const textData = await getIAModels({ hasText: 1 });
        const visionData = await getIAModels({ hasVision: 1 });
        const translationData = await getIAModels({ hasTranslation: 1 });
        
        setModels({
          text: textData.success ? textData.models : [],
          vision: visionData.success ? visionData.models : [],
          translation: translationData.success ? translationData.models : []
        });
      } catch (error) {
        debug.error(config, 'Error fetching IA models:', error);
      }
    };
    fetchModels();
  }, []);

  return {
    languages,
    models,
    aiWorkingLanguages,
    setAiWorkingLanguages
  };
};
